import loginIcon from "./loginImage.svg";
import eyeIcon from "./eye.svg";
import rightAngleIcon from "./rightAngle.svg";
import actionIcon from "./action.svg";
import HomeIcon from "./Home1.svg";
import HomeIconRed from "./Home-red.svg";
import CaseManagementIcon from "./case-management.svg";
import CaseManagementIconRed from "./case-management-filled.svg";
import MisReportsIcon from "./mis-reports.svg";
import MisReportsIconRed from "./mis-reports-filled.svg";
import VendorManagementIcon from "./vendor-management.svg";
import VendorManagementIconRed from "./vendor-management-filled.svg";
import ApprovalIcon from "./Approve.svg";
import ApprovalIconRed from "./approve-filled.svg";
import InvoiceIcon from "./invoice.svg";
import InvoiceIconRed from "./invoice-filled.svg";
import AuditIcon from "./audit.svg";
import crossIcon from "./cross.svg";
import uploadIcon from "./uploadIcon.svg";
import AodbeIcon from "./AodbeIcon.svg";
import nextBtnPdf from "./First_Page.svg";
import previousBtnPdf from "./Last_page.svg";
import reject from "./reject.svg";
import flag from "./flag.svg";
import approveSuccess from "./approveSuccess.svg";
import BussinessLogo from "./BussinessLogo.svg";
import CtrlNLogo from "./ctrl+nLogo.svg";
import ScrollToTopLogo from "./ScrollToTop.svg";
import AuditIconFilled from "./Audit-filled.svg";
import logoutIcon from "./logoutIcon.svg";
import settingIcon from "./settingIcon.svg";
import userIcon from "./userIcon.svg";
import switchRoleIcon from "./switchRoleIcon.svg";
import approveAction from "./actionsIcon/approveAction.svg";
import raiseQueryAction from "./actionsIcon/raiseQueryAction.svg";
import assignBlockAction from "./actionsIcon/assignBlockAction.svg";
import caseDescriptionAction from "./actionsIcon/caseDesAction.svg";
import caseHistory from "./actionsIcon/case-history-action.svg";
import gradeCaseAction from "./actionsIcon/gradeCaseAction.svg";
import reAssignAction from "./actionsIcon/ReAssignAction.svg";
import reOpenAction from "./actionsIcon/reOpenAction.svg";
import rejectAction from "./actionsIcon/rejectAction.svg";
import submitFinalAction from "./actionsIcon/submitFinalAction.svg";
import uploadDocumentsAction from "./actionsIcon/uploadDocAction.svg";
import vendorAssesmentAction from "./actionsIcon/vendorAssesmentAction.svg";
import holdUnholdAction from "./actionsIcon/holdUnholdAction.svg";
import peerReviewIcon from "./actionsIcon/peerReviewIcon.svg";
import hoverApprove from "./hoverActionsIcon/hoverApprove.svg";
import hoverAssignBlock from "./hoverActionsIcon/hoverAssignBlock.png";
import hoverCaseDes from "./hoverActionsIcon/hoverCaseDes.svg";
import hoverCaseHistory from "./hoverActionsIcon/hoverCaseHistory.svg";
import hoverFlag from "./hoverActionsIcon/HoverFlag.svg";
import hoverGradeCase from "./hoverActionsIcon/hoverGradeCase.svg";
import hoverRaiseQuery from "./hoverActionsIcon/hoverRaiseQuery.svg";
import hoverReAssign from "./hoverActionsIcon/hoverReAssign.svg";
import hoverReject from "./hoverActionsIcon/hoverReject.svg";
import hoverReOpen from "./hoverActionsIcon/hoverReOpen.svg";
import hoverSubmitFinal from "./hoverActionsIcon/hoverSubmitFinal.svg";
import hoverUploadDoc from "./hoverActionsIcon/hoverUploadDoc.svg";
import hoverVendorAssesment from "./hoverActionsIcon/hoverVendorAssesment.svg";
import hoverActionHand from "./hoverActionsIcon/hoverActionHand.svg";
import actionUpArrow from "./hoverActionsIcon/actionUpArrow.svg";
import hoverHoldUnholdIcon from "./hoverActionsIcon/hoverHoldUnholdIcon.svg";
import hoverPeerReviewIcon from "./hoverActionsIcon/hoverPeerReviewIcon.svg";
import handAction from "./handAction.svg";
import viewAction from "./viewAction.svg";
import flagAction from "./actionsIcon/flagAction.svg";
import redColorDownArrow from "./redColorDownArrow.svg";
import CancelIcon from "./cancel.svg";
import FilledCancelIcon from "./filledCancelIcon.svg";
import VerifiedIcon from "./verifiedIcon.svg";
import backArrow from "./backArrow.svg";
import preview from "./preview.svg";
import addIcon from "./AddIconButton.svg";
import backArrowBold from "./backArrowBold.svg";
import feedbackFormSVG from "./feedbackForm.svg";
import ErrorExclamation from "../ErrorExclamation.svg";
import rightArrow from "../Svg/rightArrow.svg";
import alert from "../Svg/alert.svg";
import chaseLogo from "./chaseLogo.svg";
import DownloadIcon from "./DownloadIcon.svg";
import DownloadUp from "./DownloadUp.svg";
import SavedIcon from "./SavedIcon.svg";
import AddVendorIcon from "./AddVendorIcon.svg";
import PanGstDetailsIcon from "./PanGstDetailsIcon.svg";
import CompanyDetailsIcon from "./CompanyDetailsIcon.svg";
import BankDetailsIcon from "./BankDetailsIcon.svg";
import ServiceDetailsIcon from "./ServiceDetailsIcon.svg";
import DocumentsIcon from "./DocumentsIcon.svg";
import ActiveSaveIcon from "./ActiveSaveIcon.svg";
import DisabledSaveIcon from "./DisabledSaveIcon.svg";
import ActiveNextIcon from "./ActiveNextIcon.svg";
import DisabledNextIcon from "./DisabledNextIcon.svg";
import ActiveFinishIcon from "./ActiveFinishIcon.svg";
import DisabledFinishIcon from "./DisabledFinishIcon.svg";
import deleteIcon from "./deleteIcon.svg";
import VerifiedCheck from "./VerifiedCheck.svg";
import roundCloseIcon from "./roundCloseIcon.svg";
import welcomeTour from "./welcomeTour.svg";
import sidebarMenutour from "./sidebarMenuTour.svg";
import misTour from "./mis-tour.svg";
import vendorTour from "./vendor-tour.svg";
import approvalTour from "./approval-tour.svg";
import invoiceTour from "./invoice-tour.svg";
import dashCase from "./dash-case.svg";
import dashAction from "./dash-action.svg";
import dashAgeing from "./dash-ageing.svg";
import caseTour from "./case-tour.svg";
import Bell from "./Bell.svg";
import withdrawalIcon from "./withdrawalIcon.svg";
import withdrawalHoverIcon from "./withdrawalHoverIcon.svg";
export const images = {
  loginIcon,
  rightAngleIcon,
  eyeIcon,
  actionIcon,
  crossIcon,
  HomeIcon,
  HomeIconRed,
  CaseManagementIcon,
  CaseManagementIconRed,
  MisReportsIcon,
  MisReportsIconRed,
  VendorManagementIcon,
  ApprovalIcon,
  ApprovalIconRed,
  InvoiceIcon,
  AuditIcon,
  uploadIcon,
  AodbeIcon,
  InvoiceIconRed,
  VendorManagementIconRed,
  nextBtnPdf,
  previousBtnPdf,
  reject,
  flag,
  approveSuccess,
  BussinessLogo,
  CtrlNLogo,
  ScrollToTopLogo,
  AuditIconFilled,
  logoutIcon,
  settingIcon,
  userIcon,
  switchRoleIcon,
  approveAction,
  raiseQueryAction,
  assignBlockAction,
  caseDescriptionAction,
  caseHistory,
  gradeCaseAction,
  reAssignAction,
  reOpenAction,
  rejectAction,
  submitFinalAction,
  uploadDocumentsAction,
  vendorAssesmentAction,
  hoverApprove,
  hoverAssignBlock,
  hoverCaseDes,
  hoverCaseHistory,
  hoverFlag,
  hoverGradeCase,
  hoverRaiseQuery,
  hoverReAssign,
  hoverReOpen,
  hoverReject,
  hoverUploadDoc,
  hoverSubmitFinal,
  hoverVendorAssesment,
  hoverActionHand,
  actionUpArrow,
  handAction,
  viewAction,
  flagAction,
  redColorDownArrow,
  CancelIcon,
  FilledCancelIcon,
  VerifiedIcon,
  backArrow,
  preview,
  addIcon,
  backArrowBold,
  feedbackFormSVG,
  ErrorExclamation,
  rightArrow,
  alert,
  chaseLogo,
  DownloadIcon,
  DownloadUp,
  PanGstDetailsIcon,
  CompanyDetailsIcon,
  BankDetailsIcon,
  ServiceDetailsIcon,
  DocumentsIcon,
  ActiveSaveIcon,
  DisabledSaveIcon,
  ActiveNextIcon,
  DisabledNextIcon,
  ActiveFinishIcon,
  DisabledFinishIcon,
  SavedIcon,
  AddVendorIcon,
  deleteIcon,
  VerifiedCheck,
  roundCloseIcon,
  welcomeTour,
  sidebarMenutour,
  misTour,
  vendorTour,
  approvalTour,
  invoiceTour,
  dashAction,
  dashAgeing,
  dashCase,
  caseTour,
  holdUnholdAction,
  hoverHoldUnholdIcon,
  peerReviewIcon,
  hoverPeerReviewIcon,
  Bell,
  withdrawalIcon,
  withdrawalHoverIcon,
};
